import { Grid } from '@mui/material';
import { ClientDTO } from 'wisestep-api';
import { WsDrawer } from 'wisestep-base';

import { createClientPayload } from '../helper/ClientFormHelper';

import ClientDetailsFormNew from './ClientDetailsFormNew';

interface CreateClientDrawerProps {
  open: boolean;
  onClose: () => void;
  client: ClientDTO | null;
  postSubmit?: (client: ClientDTO) => void;
}

const CreateClientDrawer = ({ open, onClose, client, postSubmit }: CreateClientDrawerProps) => {
  const clientData = client || { ...createClientPayload };

  const onClientSubmit = (client: ClientDTO) => {
    onClose();
    postSubmit && postSubmit(client);
  };

  return (
    <WsDrawer
      open={open}
      onClose={onClose}
      size="medium"
      title={client ? 'Edit Client' : 'Create Client'}
      headerSize="medium"
    >
      <Grid p={1}>
        <ClientDetailsFormNew
          source="ClientAdditionForm"
          client={clientData}
          setClient={onClientSubmit}
        />
      </Grid>
    </WsDrawer>
  );
};

export default CreateClientDrawer;
